import type { CustomDetector } from "i18next-browser-languagedetector"
import { getBusinessUnit } from "../utils/business.utils"
import type { BusinessUnit } from "../utils/business.utils"
import type { I18Language } from "./i18n.types"

const defaultBusinessUnitLanguages: Record<BusinessUnit, I18Language | undefined> = {
  Noordhoff: "nl-NL",
  Plantyn: "nl-BE",
  Liber: "sv"
}

const i18nBusinessUnitLanguageDetector: CustomDetector = {
  name: "businessUnitLanguageDetector",
  lookup: () => {
    const {
      location: { hostname }
    } = window
    if (hostname === "localhost") return "dev"

    const businessUnit = getBusinessUnit()
    if (!businessUnit) return undefined
    return defaultBusinessUnitLanguages[businessUnit]
  }
}

export default i18nBusinessUnitLanguageDetector
